import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Spinner } from "./Spinner";

type Props = {
  img: {
    alt: string;
    width: string;
    height: string;
    // maxWidth: string;
    src: string;
  };
  heading: string | JSX.Element;
  cta: string;
  loading: boolean;
  onClick: () => any;
  menu?: JSX.Element;
  btnClassName?: string;
  renderAboveCta?: () => any;
  colWidths?:
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"[];
};
export const SmallCard: React.FC<Props> = ({
  heading,
  img,
  onClick,
  cta,
  menu,
  loading,
  btnClassName,
  renderAboveCta,
  colWidths,
}) => {
  const [classes, setClasses] = React.useState("");
  return (
    // <div className="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">

    <Card className={`${classes} text-left`} style={{ width: "100%" }}>
      {menu}
      <Row
        className="align-items-center justify-content-around"
        onClick={onClick}
        onMouseEnter={() => setClasses("shadow cursor-pointer")}
        onMouseLeave={() => setClasses("")}
      >
        <Col
          xs={colWidths ? colWidths[0] : ("3" as any)}
          style={{
            // margin: "auto",
            height: img.height,
            // width: img.width,
          }}
        >
          {img.src && (
            <div className="p-2">
              <img
                alt={img.alt}
                className="fdb-icon"
                // width={img.width}
                // height={img.height}
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                }}
                src={img.src}
                // style={{ maxWidth: img.maxWidth }}
              />
            </div>
          )}
        </Col>

        <Col xs={colWidths ? colWidths[1] : ("6" as any)}>
          <div className="h5 text-truncate">
            <strong>{heading}</strong>
          </div>
        </Col>
        {renderAboveCta && renderAboveCta()}
        {cta && (
          <Col xs={colWidths ? colWidths[2] : ("3" as any)}>
            {loading && <Spinner size="md" />}
            {!loading && (
              <small>
                <Button
                  className={btnClassName || "btn--card2"}
                  variant="secondary" /*onClick={onClick}*/
                >
                  {cta}
                </Button>
              </small>
            )}
          </Col>
        )}
      </Row>
    </Card>
    // </div>
  );
};
